module.exports = __webpack_public_path__ + "static/media/empty-state-tab.b591b47a.svg";